// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container {
  max-width: 450px;
  margin: 50px auto;
  padding: 30px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.reset-password-container .title {
  color: #014D4E;
  font-size: 22px;
  font-weight: bold;
}

.reset-password-container .subtitle {
  color: #555;
  margin-bottom: 20px;
}

/* ✅ Added spacing for messages */
.reset-password-container .message-container {
  margin-bottom: 15px;
  /* ✅ Adds space between messages & New Password field */
}

.reset-password-container.password-input {
  width: 100%;
  margin-bottom: 15px;
}

/* ✅ Password Criteria Styling */
.reset-password-container .password-criteria {
  text-align: left;
  font-size: 14px;
  margin-bottom: 15px;
}

.reset-password-container .password-criteria p {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
}

.reset-password-container .check-icon {
  color: #bbb;
  /* ⚪ Light gray by default */
  font-size: 16px;
  transition: color 0.3s ease-in-out;
}

.reset-password-container .checked {
  color: #34a853 !important;
  /* ✅ Turns green when condition is met */
}

.reset-password-container .valid {
  color: #34a853;
  /* ✅ Soft green text for valid conditions */
}

.reset-password-container .pending {
  color: #888;
  /* ⚪ Soft gray for unmet conditions */
}

.reset-password-container .submit-button {
  width: 100%;
  background-color: #1f415b;
  border: none;
  margin-top: 15px;
}

.reset-password-container .submit-button:hover {
  background-color: #005b60;
}`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/components/ResetPassword/ResetPassword.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".reset-password-container {\n  max-width: 450px;\n  margin: 50px auto;\n  padding: 30px;\n  border-radius: 8px;\n  background-color: white;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.reset-password-container .title {\n  color: #014D4E;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.reset-password-container .subtitle {\n  color: #555;\n  margin-bottom: 20px;\n}\n\n/* ✅ Added spacing for messages */\n.reset-password-container .message-container {\n  margin-bottom: 15px;\n  /* ✅ Adds space between messages & New Password field */\n}\n\n.reset-password-container.password-input {\n  width: 100%;\n  margin-bottom: 15px;\n}\n\n/* ✅ Password Criteria Styling */\n.reset-password-container .password-criteria {\n  text-align: left;\n  font-size: 14px;\n  margin-bottom: 15px;\n}\n\n.reset-password-container .password-criteria p {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 4px 0;\n}\n\n.reset-password-container .check-icon {\n  color: #bbb;\n  /* ⚪ Light gray by default */\n  font-size: 16px;\n  transition: color 0.3s ease-in-out;\n}\n\n.reset-password-container .checked {\n  color: #34a853 !important;\n  /* ✅ Turns green when condition is met */\n}\n\n.reset-password-container .valid {\n  color: #34a853;\n  /* ✅ Soft green text for valid conditions */\n}\n\n.reset-password-container .pending {\n  color: #888;\n  /* ⚪ Soft gray for unmet conditions */\n}\n\n.reset-password-container .submit-button {\n  width: 100%;\n  background-color: #1f415b;\n  border: none;\n  margin-top: 15px;\n}\n\n.reset-password-container .submit-button:hover {\n  background-color: #005b60;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
